import { ConditionalWrapper } from "@verity/components";
import i18n from "../../../../../i18n";
import { addFullScreenClass } from "./videoControlHelper";
import styles from "./VideoControls.module.css";

type VideoControlLayoutProps = {
	children: React.ReactNode;
	inFullscreen: boolean;
	controlContainerRef: React.RefObject<HTMLDivElement>;
	/** Appended after the base/fullscreen classes, so a caller can override sizing (e.g. height/padding)
	 * without forking this component. Optional — existing callers are unaffected. */
	className?: string;
	ariaLabel?: string;
};
export default function VideoControlLayout({
	children,
	inFullscreen,
	controlContainerRef,
	className,
	ariaLabel,
}: VideoControlLayoutProps) {
	return (
		<div
			role="group"
			aria-label={
				ariaLabel ??
				i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.ariaLabels.videoPlayerControls")
			}
			className={[addFullScreenClass(styles.controlContainer, inFullscreen), className].filter(Boolean).join(" ")}
			ref={controlContainerRef}
		>
			{children}
		</div>
	);
}

type VideoControlButtonWrapperProps = {
	children: React.ReactNode;
};

export function VideoControlButtonWrapper({ children }: VideoControlButtonWrapperProps) {
	return <div className={styles.videoControlButtonWrapper}>{children}</div>;
}

type VideoWrapperProps = {
	children: React.ReactNode;
	inFullscreen: boolean;
	showTimestamps: boolean;
	useDoubleWrappers?: boolean; // should definitely clean this -> for some reason the VideoPlayer doesn't need this
};

export function VideoWrapper({ children, inFullscreen, showTimestamps, useDoubleWrappers = true }: VideoWrapperProps) {
	// can clean up the double wrappers??
	return (
		<div id="entire_player" className={addFullScreenClass(styles.videoWrapper, inFullscreen)}>
			<ConditionalWrapper
				condition={useDoubleWrappers}
				whenTrue={(children) => (
					<div
						className={addFullScreenClass(styles.videoContainer, inFullscreen)}
						style={showTimestamps ? { width: "fit-content" } : {}}
					>
						{children}
					</div>
				)}
			>
				{children}
			</ConditionalWrapper>
		</div>
	);
}
